import { OwnerEnum } from './types';

export const HUBSPOT_FILTER_EVENTS: Record<string, true | readonly OwnerEnum[]> = {
  cancel_flow_retention_offer_accept_click: true,
  cancel_flow_retention_offer_eligibility_denied: true,
  cancel_flow_step1_close_click: true,
  cancel_flow_step2_close_click: true,
  cancel_flow_step2_keep_benefits_click: true,
  dashboard_clients_card_clicked: true,
  dashboard_v2_viewed: true,
  header_help_clicked: true,
  login_attempt_successful: true,
  menu_category_expanded: true,
  menu_gamification_details_clicked: true,
  menu_gamification_details_viewed: true,
  menu_item_selected: true,
  menu_new_tag_clicked: true,
  menu_new_tag_viewed: true,
  menu_profile_mgm_clicked: true,
  notification_tag_clicked: true,
  notification_tag_viewed: true,
  profile_info_displayed: true,
  subscription_b2b_cancellation_whatsapp_clicked: true,
  subscription_regularization_banner_viewed: true,
  subscription_regularization_card_selected: true,
  subscription_regularization_charge_failed: true,
  subscription_regularization_charge_submitted: true,
  subscription_regularization_modal_dismissed: true,
  subscription_regularization_modal_viewed: true,
  subscription_regularization_started: true,
  subscription_regularization_support_clicked: true,
  subscription_support_clicked: true,
  // whatsapp_button_clicked also fires with owner Inovação (JusZap/JusGPT)
  whatsapp_button_clicked: [OwnerEnum.JORNADA],
  // Squad Inovação (IHE-48). jurisprudencia_* chega do micro-front via iframe
  // e é enriquecido em pages/Jurisprudencia antes de passar pelo tracker.
  ia_personalizada_checkout_completed: true,
  ia_personalizada_checkout_opened: true,
  jurisprudencia_external_opened: true,
  jurisprudencia_search: true,
  jus_gpt_chat_message_sent: true,
  jus_zap_upgrade_button_clicked: true,
  juscont_checkout_completed: true,

  // Squad GDC
  jus_processos_cnj_manually_added: true,
  jus_processos_dashboard_last_step_clicked: true,
  jus_processos_dashboard_monitor_clicked: true,
  jus_processos_deadline_created: true,
  jus_processos_deadline_page_viewed: true,
  jus_processos_deadlines_filter: true,
  jus_processos_lawsuit_filter: true,
  jus_processos_lawsuit_publications_read: true,
  jus_processos_lawsuit_steps_read: true,
  jus_processos_lawsuits_deleted: true,
  jus_processos_lawsuits_filtered: true,
  jus_processos_my_lawsuits_page_viewed: true,
  jus_processos_new_lawsuit_added: true,
  jus_processos_oab_manually_added: true,
  jus_processos_realtime_toast_clicked: true,
  jus_processos_realtime_toast_displayed: true,
  jus_processos_step_marked_as_important: true,
  jus_processos_step_marked_as_non_important: true,
  jus_processos_sync_empty_state_cta_clicked: true,
  jus_processos_sync_empty_state_viewed: true,
};

/**
 * Squads que já fecharam a planilha: todo evento delas sai com o campo, e
 * quem não está no registro vai como `false`. As demais seguem sem o campo.
 */
const OWNERS_WITH_FILTRO_HUBSPOT: readonly OwnerEnum[] = [
  OwnerEnum.JORNADA,
  OwnerEnum.INOVACAO,
  OwnerEnum.GDC,
];

export function resolveFiltroHubspot(
  event: string,
  owner: string,
): boolean | undefined {
  const registryEntry = HUBSPOT_FILTER_EVENTS[event];

  if (registryEntry === true) {
    return true;
  }

  if (Array.isArray(registryEntry) && registryEntry.includes(owner as OwnerEnum)) {
    return true;
  }

  return OWNERS_WITH_FILTRO_HUBSPOT.includes(owner as OwnerEnum)
    ? false
    : undefined;
}
